import {H2hDomainService} from "../../../domain/h2h/services/h2h.domain-service";
import {H2H} from "../h2h-widget.consts";
import {H2hFetchHandler} from "../../../core/handlers/h2h.fetch-handler";
import {H2hWidgetController} from "../h2h-widget.controller";

export class H2hWidgetFetchHandler extends H2hFetchHandler {
  controller: H2hWidgetController;

  static injectables = [H2hDomainService];

  async action() {
    await super.action();

    await this.controller.action(H2H.ACTION_TYPES.displayHandler)
  }
}
